import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.e4{animation-duration:0.5s;}.ssr-plugin'
import '.e5{animation-iteration-count:infinite;}.ssr-plugin'
import '.e6{width:25px;}.ssr-plugin'
import '.e7{height:25px;}.ssr-plugin'
import '.a0{border-radius:50%;}.ssr-plugin'
import '.e8{animation-timing-function:ease-out;}.ssr-plugin'
import '.e9{animation-duration:2.24s;}.ssr-plugin'
import '.u{position:absolute;}.ssr-plugin'
import { type Style, styled, keyframes } from 'inlines'
import { useEffect, useState } from 'react'
import { useTheme } from '../providers/useTheme'

const calcSvg = (val) => {
  const r = 84
  const c = Math.PI * (r * 2)
  if (val < 0) {
    val = 0
  } else if (val > 100) {
    val = 100
  }

  return ((100 - val) / 100) * c
}

type ProgressIndicatorProps = {
  size?: number
  style?: Style
}

const scaleAnim = keyframes({
  '0%': {
    transform: 'scale(0.01)',
    opacity: 1,
  },
  '12.5%': {
    opacity: 1,
  },
  '50%': {
    transform: 'scale(1)',
    opacity: 0,
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 0,
  },
})

export const SpinningLoader = ({
  size = 25,
  style,
}: ProgressIndicatorProps) => {
  const [percentage, setPercentage] = useState(0)
  const [hitLimit, setHitLimit] = useState(false)

  const { colors } = useTheme()

  useEffect(() => {
    const DURATION = 30e3
    const LIMIT = 90

    const INTERVAL = Math.floor(DURATION / LIMIT)

    const intervalId = setInterval(() => {
      setPercentage((p) => {
        if (hitLimit) return p

        const n = p + Math.floor(Math.random() * 1) + 1

        if (n >= LIMIT) {
          setHitLimit(true)
          return LIMIT
        }

        return n
      })
    }, INTERVAL)

    return () => {
      clearInterval(intervalId)
    }
  }, [hitLimit])

  return (
    <div className="a d c"
    >
      <styled.div className="s e4 e5"
        style={{
          '@keyframes': {
            '0%': {
              opacity: 0.5,
            },
            '50%': {
              opacity: 1,
            },
            '100%': {
              opacity: 0.5,
            },
          },
          width: size,
          height: size,
          ...style,
        }}
      >
        <svg
          style={{
            transform: 'rotate(-90deg)',
          }}
          strokeWidth="8px"
          width={size}
          height={size}
          viewBox="0 0 200 200"
        >
          <circle
            r="84"
            cx="100"
            cy="100"
            fill="transparent"
            strokeDasharray="527.781333333"
            style={{
              stroke: colors.primaryAccent,
              opacity: 0.15,
            }}
          />
          <circle
            r="84"
            cx="100"
            cy="100"
            fill="transparent"
            strokeDasharray="527.781333333"
            strokeDashoffset={`${calcSvg(percentage)}px`}
            style={{
              transition: 'stroke-dashoffset 0.5s linear',
              stroke: colors.primaryAccent,
            }}
          />
        </svg>
      </styled.div>
      {hitLimit && (
        <div className="e6 e7 a0 e8 e5 e9 u"
          style={{
            background: colors.primaryAccent,
            animationName: scaleAnim,}}
        />
      )}
    </div>
  )
}
